import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IChannel } from '@/entities/channel';
import { AddChannelToCompanyDialog } from '@/features/channels';
import { TableSettingsMenuById } from '@/shared/ui/Table';
import { getRoutePath } from '@/shared/utils/routes';

type ChannelsListSettingsProps = {
  channel: IChannel;
  onDelete: (id: string) => Promise<void>;
};

export const ActionsMenu = ({
  channel,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDelete,
}: ChannelsListSettingsProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [openIsAddChannelDialog, setOpenIsAddChannelDialog] = useState(false);

  const { id: channelId, company_id: companyId } = channel;

  const handleSettings = () => {
    if (channelId) {
      navigate(
        getRoutePath('MAIN', 'CHANNEL')
          .replace(':id', channelId)
          .replace(':tab', 'settings')
      );
    }
  };

  // const handleDelete = async () => {
  //   if (channelId) {
  //     await onDelete(channelId);
  //   }
  // };

  const handleOpenAddChannelDialog = () => {
    setOpenIsAddChannelDialog(true);
  };

  const handleCloseAddChannelDialog = () => {
    setOpenIsAddChannelDialog(false);
  };

  return (
    <div>
      <TableSettingsMenuById
        menuItems={[
          {
            label: t('channels:list.menu.settings'),
            onClick: handleSettings,
          },
          {
            label: t(
              companyId
                ? 'channels:list.menu.transferChannelToNewCompany'
                : 'channels:list.menu.addChannelToCompany'
            ),

            onClick: handleOpenAddChannelDialog,
          },
          // {
          //   label: t('channels:deleteChannel'),
          //   onClick: handleDelete,
          //   color: 'error',
          // },
        ]}
      />
      <AddChannelToCompanyDialog
        open={openIsAddChannelDialog}
        onClose={handleCloseAddChannelDialog}
        channelId={channelId}
        companyId={companyId}
        mode="transferOrRemove"
      />
    </div>
  );
};
